import React from 'react';
import styles from './ProductsPromotions.module.scss';
import { Container, Row } from 'reactstrap';
import DataTable from 'react-data-table-component';

const productsData = [
    {
        id: 1,
        productName: 'Product A',
        sales: '$5,000',
        unitsSold: '100',
        returnRate: '2%',
    },
    {
        id: 2,
        productName: 'Product A',
        sales: '$5,000',
        unitsSold: '100',
        returnRate: '2%',
    },
    {
        id: 3,
        productName: 'Product A',
        sales: '$5,000',
        unitsSold: '100',
        returnRate: '2%',
    },
    {
        id: 4,
        productName: 'Product A',
        sales: '$5,000',
        unitsSold: '100',
        returnRate: '2%',
    },
    {
        id: 5,
        productName: 'Product A',
        sales: '$5,000',
        unitsSold: '100',
        returnRate: '2%',
    },
];

const productsColumns = [
    {
        name: "Product Name",
        selector: (row) => row.productName,
    },
    {
        name: "Sales",
        selector: (row) => row.sales,
    },
    {
        name: "Units Sold",
        selector: (row) => row.unitsSold,
    },
    {
        name: "Return Rate",
        selector: (row) => row.returnRate,
    },
];

const promotionsData = [
    {
        id: 1,
        promotionType: 'Discount',
        campaign: 'Summer Sale',
        salesIncrease: '20%',
        trafficIncrease: '25%',
        conversionRate: '4%',
    },
    {
        id: 2,
        promotionType: 'Discount',
        campaign: 'Summer Sale',
        salesIncrease: '20%',
        trafficIncrease: '25%',
        conversionRate: '4%',
    },
    {
        id: 3,
        promotionType: 'Discount',
        campaign: 'Summer Sale',
        salesIncrease: '20%',
        trafficIncrease: '25%',
        conversionRate: '4%',
    },
    {
        id: 4,
        promotionType: 'Discount',
        campaign: 'Summer Sale',
        salesIncrease: '20%',
        trafficIncrease: '25%',
        conversionRate: '4%',
    },
    {
        id: 5,
        promotionType: 'Discount',
        campaign: 'Summer Sale',
        salesIncrease: '20%',
        trafficIncrease: '25%',
        conversionRate: '4%',
    },
];

const promotionsColumns = [
    {
        name: "Promotion Type",
        selector: (row) => row.promotionType,
    },
    {
        name: "Campaign Name",
        selector: (row) => row.campaign,
    },
    {
        name: "Sales Increase",
        selector: (row) => row.salesIncrease,
    },
    {
        name: "Traffic Increase",
        selector: (row) => row.trafficIncrease,
    },
    {
        name: "Conversion Rate",
        selector: (row) => row.conversionRate,
    },
];

const customStyles = {
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            fontSize: '15px',
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 20px',
        },
    },
};

const ProductsPromotions = () => {
    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.tableSection}>
                <div className={styles.sectionTitle}>
                    <h5 className={styles.sectionSubHeading}>Top Performing Products</h5>
                </div>

                <div className={styles.tableDataWrapper}>
                    <Row className={styles.tableDataRow}>
                        <DataTable
                            columns={productsColumns}
                            data={productsData}
                            customStyles={customStyles}
                        />
                    </Row>
                </div>

                <div className={styles.sectionTitle}>
                    <h5 className={styles.sectionSubHeading}>Top Performing Products</h5>
                </div>

                <div className={styles.tableDataWrapper}>
                    <Row className={styles.tableDataRow}>
                        <DataTable
                            columns={promotionsColumns}
                            data={promotionsData}
                            customStyles={customStyles}
                        />
                    </Row>
                </div>
            </Container>

            <h5 className={styles.sectionHeading}>Graphs:</h5>
            <Container fluid className={styles.graphSection}>
                <p>Product Performance:</p>
                <ul>
                    <li>A pie chart representing the sales distribution among top-performing products.</li>
                </ul>
            </Container>
        </div>
    )
}

export default ProductsPromotions;